import { http_client } from "@/plugins/http_client";


const getEspecificoGastos = async (params = {}) => await http_client('/api/gestion-planilla/listar-especifico-gastos', params, "get")
const getIngresos = async (params = {}) => await http_client('/api/gestion-planilla/listar-ingresos', params, "get")
const createPlanilla = async (body) => await http_client('/api/gestion-planilla/apertura-planilla', body, "post")
const getPlanillaAperturada = async (params = {}) => await http_client('/api/gestion-planilla/index-apertura-planilla-detalle', params, "get")
const getIndexPlanilla = async (params = {}) => await http_client('/api/gestion-planilla/index-planilla', params, "get")
const getCategoriaDescuentos = async (params = {}) => await http_client('/api/gestion-planilla/descuentos/catalogos/categoria-descuento', params, "get")
const getTipoAcreedor = async (params = {}) => await http_client('/api/gestion-planilla/descuentos/catalogos/tipo-acreedor', params, "get")
const getAcreedor = async (params = {}) => await http_client('/api/gestion-planilla/descuentos/catalogos/acreedor', params, "get")
const getSobreIngresos = async (params = {}) => await http_client('/api/gestion-planilla/descuentos/catalogos/ingreso', params, "get")
const closePeriodoJustificacion = async (body = {}) => await http_client('/api/gestion-planilla/cerrar-justificacion', body, "put")
const openPeriodoJustificacion = async (body = {}) => await http_client('/api/gestion-planilla/observaciones/modificacion-apertura-justificacion', body, "post")
const obtenerJustificaciones = async (idPlanilla, params = {}) => await http_client(`/api/gestion-planilla/observaciones/modificacion-apertura-justificacion/${idPlanilla}`, params, "get")
const obtenerDocumentoJustificacion = async (idPlanilla, idJustificacion, params = {}) => await http_client(`/api/gestion-planilla/observaciones/modificacion-apertura-justificacion/${idPlanilla}/documento/${idJustificacion}`, params, "get", {}, true, "blob")
const closePlanilla = async (body = {}) => await http_client('/api/gestion-planilla/cerrar-planilla', body, "put")
const getDetallePlaza = async (params = {}) => await http_client('/api/gestion-planilla/obtener-detalle-plaza', params, "get")
const getEmpleadoComplementataria = async (params = {}) => await http_client('/api/gestion-planilla/obtener-empleado-complementaria', params, "get")
const getPlazaEmpleado = async (params = {}) => await http_client('/api/gestion-planilla/obtener-plaza-empleado', params, "get")
const getEstados = async (params = {}) => await http_client('/api/gestion-planilla/obtener-estados', params, "get")
const desbloquearNomina = async (id, params = {}) => await http_client(`/api/gestion-planilla/nomina/${id}/desbloquear`, params, "get")

//Ingresos de Ley
const getEspecificoGasto = async () => await http_client(`/api/gestion-planilla/especifico-gasto`, {}, "get")
const getOtrosIngresos = async (body = {}) => await http_client(`/api/gestion-planilla/index-otros-ingresos`, body, "get")
const getFormaCalculo = async () => await http_client(`/api/gestion-planilla/formas-calculo`, {}, "get")
const getCifrados = async () => await http_client(`/api/gestion-planilla/cifrado-presupuestario`, {}, "get")
const getUnidades = async () => await http_client(`/api/gestion-planilla/establecimiento/unidades`, {}, "get")
const getListaIngresos = async (id) => await http_client(`/api/gestion-planilla/lista-ingresos/${id}`, {}, "get")

const modificarIngresosLey = async (body) => await http_client(`/api/gestion-planilla/modificar-ingreso-planilla`, body, "post")
const getOtroIngreso = async (id) => await http_client(`/api/gestion-planilla/get-otro-ingreso/${id}`, {}, "get")
const addOtroIngreso = async (body) => await http_client(`/api/gestion-planilla/agregar-otro-ingreso`, body, "post")
const deleteOtroIngreso = async (id) => await http_client(`/api/gestion-planilla/eliminar-otro-ingreso/${id}`, {}, "delete")
const updateOtroIngreso = async (id, body) => await http_client(`/api/gestion-planilla/actualizar-otro-ingreso/${id}`, body, "put")
const deleteEmpleadoComplementaria = async (body) => await http_client(`/api/gestion-planilla/eliminar-empleado-complementaria`, body, "delete")
const iniciarConfiguracion = async (params = {}) => await http_client(`/api/gestion-planilla/${params.type}`, params, "get")
const getEmpleadoConfigurar = async (id, params = {}) => await http_client(`api/gestion-planilla/get-empleado-configurar/${id}`, params, "get")
const finalizarConfiguracionNomina = async (body = {}) => await http_client(`api/gestion-planilla/finalizar-configuracion-nomina/${body.id}`, body, "put")
const estadoEditarNomina = async (body = {}) => await http_client(`api/gestion-planilla/estado-editar-nomina/${body.id}`, body, "put")
const obtenerAportesPatronales = async (id, params = {}) => await http_client(`api/gestion-planilla/obtener-aportes-patronales/${id}`, params, "get")
const actualizarEspecificoGasto = async (id, body = {}) => await http_client(`api/gestion-planilla/actualizar-especifico-gasto/${id}`, body, "put")
const obtenerCategoriasDescuentos = async () => await http_client(`api/gestion-planilla/obtener-categorias-descuentos`, {}, "get")
const categoriaDescuentoPlanilla = async (params) => await http_client(`api/gestion-planilla/categoria-descuento/planilla`, params, "get")
const ingresoEmpleadoDescuento = async (params) => await http_client(`api/gestion-planilla/ingreso-empleado/descuento`, params, "post")
const obtenerIngresosDeduccionLey = async (params) => await http_client(`api/gestion-planilla/obtener-ingresos-deduccion-ley/${params.id}/${params.type}`, params, "get")
const eliminarDescuenoIngreso = async (params) => await http_client(`api/gestion-planilla/eliminar-descuento-ingreso/${params.id}`, params, "delete")
const otroIngresoEmpleado = async (params) => await http_client(`api/gestion-planilla/otro-ingreso-empleado`, params, "post")

//Renta
const postRentaIngreso = async (id, params = {}) => await http_client(`/api/gestion-planilla/renta-ingreso-empleado/${id}`, params, 'post')
const deleteRentaIngreso = async (id) => await http_client(`/api/gestion-planilla/renta-ingreso-empleado/${id}`, {}, 'delete')
const eliminarOtroIngresoEmpleado = async (id) => await http_client(`/api/gestion-planilla/eliminar-otro-ingreso-empleado/${id}`, {}, 'delete')

const procesarEstadoPlanilla = async (params = {}) => await http_client(`/api/gestion-planilla/procesar-estado-planilla`, params, 'post')
const procesarEstadoPlanillaFD = async (body = {}) => await http_client(`/api/gestion-planilla/procesar-estado-planilla`, body, 'post', {
    headers: { "content-type": "multipart/form-data" },
})

//Cifrados
const listarCifrados = async (idPlanilla, params = {}) => await http_client(`/api/v1/planilla/${idPlanilla}/cifrados`, params, 'get')

const actualizarCifrados = async (idPlanilla, body = {}) => await http_client(`/api/v1/planilla/${idPlanilla}/cifrados`, body, 'put')

const listarCifradosSistemaPago = async (params = {}) => await http_client(`api/gestion-planilla/cifrados-presupuestarios`, params, 'get')

//Boleta de Pago
const verBoletaPago = async (id, params = {}) => await http_client(`/api/v1/planilla/nomina/boleta-pago/${id}/pdf`, params, 'get')

const enviarBoleta = async (id, params = {}) => await http_client(`/api/v1/planilla/nomina/boleta-pago/enviar/${id}`, params, 'post')

const enviarBoletas = async (id, params = {}) => await http_client(`/api/v1/planilla/nomina/boleta-pago/enviar-grupal/${id}`, params, 'post')
const boletasEnviadas = async (id, params = {}) => await http_client(`/api/v1/planilla/nomina/boleta-pago/boletas-enviadas/${id}`, params, 'get')

// Observaciones
const getObservaciones = async (idPlanilla, params = {}) =>
    await http_client(`/api/gestion-planilla/${idPlanilla}/observaciones`, params, 'get')

const descargarArchivo = async (id_planilla_observacion) => {
    return await http_client(`api/gestion-planilla/observaciones/${id_planilla_observacion}/descargar`, {}, "get", {}, true, "blob");
}

const archivosSafi = async (id, params = {}) => await http_client(`/api/v1/reporte-planilla/documentos-safi`, { id_planilla: id, ...params }, 'get');

// Empleados que pertenecen a UFI
const getEmpleadosUnidadFinanciera = async (params = {}) => {
    return await http_client(`/api/gestion-planilla/empleados-unidad-financiera`, params, "get");
};

// Nuevo flujo
const getMeses = async () => await http_client('/api/gestion-planilla/meses', {}, "get")
const getYears = async () => await http_client('/api/gestion-planilla/anios', {}, "get")
const getPlanillas = async (params = {}) => await http_client('/api/gestion-planilla/planilla/aperturas', params, "get")
const getPlanillasHacienda = async (params = {}) => await http_client('/api/planilla/responsables/gestion-planilla/hacienda', params, "get")

const getEstadoPlanilla = async () => {
    return await http_client(`/api/gestion-planilla/planilla/estado`, {}, "get");
}

const getTiposPlanilla = async () => await http_client('/api/gestion-planilla/planilla/tipos', {}, "get")

const getSistemas = async () => await http_client('/api/gestion-planilla/planilla/sistemas-pago', {}, "get")

const aperturarPlanilla = async (body, suppressErrorAlert = false) => await http_client('/api/gestion-planilla/planilla', body, "post", {}, true, "json", undefined, suppressErrorAlert)

const getInformacionPlanilla = async (id) => await http_client(`/api/gestion-planilla/planilla/informacion/${id}`, {}, "get")
const getInformacionPlanillaHacienda = async (id) => await http_client(`/api/planilla/responsables/planilla-hacienda/${id}`, {}, "get")

const getEstadoCargaEmpleado = async (id) => await http_client(`/api/gestion-planilla/obtener-estado-cargado/${id}`, {}, "get")

const getEmpleadosPlanilla = async (id, params = {}) => await http_client(`/api/gestion-planilla/planilla/${id}/nomina`, params, "get")

const getTipoDocumento = async () => await http_client(`api/gestion-planilla/planilla/tipos-documentos`, {}, "get")

const getTipoUnidadOrganizativa = async () => await http_client(`api/gestion-planilla/planilla/unidades-organizativas`, {}, "get")

const verificacionEmpleado = async (idNominaPlanilla, params = {}) => await http_client(`/api/gestion-planilla/nomina/${idNominaPlanilla}/verificacion`, params, "put")

const asignarMuestra = async (idNominaPlanilla, params = {}) => await http_client(`/api/gestion-planilla/planilla/muestra/${idNominaPlanilla}`, params, "post")

const cambiarFase = async (idPlanilla, codigoFase, params = {}) => await http_client(`/api/gestion-planilla/${idPlanilla}/fase/${codigoFase}`, params, "post")

const getDetalleEmpleado = async (id_planilla, id_empleado_puesto) => await http_client(`/api/gestion-planilla/planilla/${id_planilla}/empleado/${id_empleado_puesto}`, {}, "get")

const getIngresosDeducciones = async (id) => await http_client(`/api/gestion-planilla/balanceo-empleado/${id}`, {}, "get")

const getHistoricoReapertura = async (id) => await http_client(`/api/gestion-planilla/planilla/historico-periodos-justificacion/${id}`, {}, "get")

const getEmpleadosSelect = async (params) => await http_client(`/api/gestion-planilla/planilla/empleados`, params, "get")

const getEmpleadosComplementaria = async (params) => await http_client(`/api/gestion-planilla/obtener-empleados-complementaria`, params, "get")
const getEmpleadosQuincenaVeinticinco = async (idPlanilla, params = {}) => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/quincena-veinticinco/empleados`, params, "get")
const guardarEmpleadosQuincenaVeinticinco = async (idPlanilla, body = {}) => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/quincena-veinticinco/empleados`, body, "post")
const getEmpleadosQuincenaVeinticincoHacienda = async (idPlanilla, params = {}) => await http_client(`/api/planilla/responsables/planilla-hacienda/${idPlanilla}/quincena-veinticinco/empleados`, params, "get")
const getEmpleadosAguinaldo = async (id, params = {}) => await http_client(`/api/gestion-planilla/planilla/${id}/aguinaldo/empleados`, params, "get")
const guardarEmpleadosAguinaldo = async (id, body) => await http_client(`/api/gestion-planilla/planilla/${id}/aguinaldo/empleados`, body, "post")

const enviarBoletasDePago = async (id, params = {}) => await http_client(`/api/v1/planilla/nomina/boleta-pago/enviar/${id}`, params, 'post')

const balanceoEmpleado = async (id, params = {}) => await http_client(`/api/gestion-planilla/balanceo-empleado/${id}`, params, "get")

const verificarEmpleado = async (idNominaPlanilla, params = {}) => await http_client(`/api/gestion-planilla/nomina/${idNominaPlanilla}/verificacion`, params, "put")

const justificarInconsistencia = async (idNominaPlanilla, params = {}) => await http_client(`/api/gestion-planilla/nomina/${idNominaPlanilla}/justificar-inconsistencia`, params, "put")
const registrarMovimientoEmpleado = async (idPlanilla, idNominaPlanilla, accion, formData) => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/nomina/${idNominaPlanilla}/${accion}`, formData, "post")
const listarMovimientosEmpleado = async (idPlanilla, page = 1) => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/movimientos`, { page }, "get")
const obtenerDocumentoMovimiento = async (idPlanilla, idMovimiento, modo = "ver") => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/movimientos/${idMovimiento}/documento`, { modo }, "get", {}, true, "blob")

const historicoRenta = async (idNominaPlanilla, params = {}) => await http_client(`/api/gestion-planilla/obtener-historico-renta/${idNominaPlanilla}`, params, "get")

const abrirPeriodoJustificacion = async (params = {}) => await http_client(`/api/gestion-planilla/planilla/aperturar-periodo-justificacion`, params, "post")

const crearHistoricoRenta = async (params = {}) => await http_client(`/api/renta/historico`, params, "post")

const guardarConstanciaRenta = async (params = {}) => await http_client(`/api/gestion-planilla/planilla/guardar-documento-renta`, params, "post")

const descargarConstanciaRenta = async (id) => await http_client(`/api/gestion-planilla/planilla/constancia-renta/${id}`, {}, "get", {}, true, "blob")

const descargarBoletaPago = async (idNominaPlanilla) => await http_client(`/api/gestion-planilla/nomina/${idNominaPlanilla}/boleta-pago`, {}, "get", {}, true, "blob")

const guardarEmpleadoComplementaria = async (params = {}) => await http_client(`/api/gestion-planilla/complementaria/empleado`, params, "post")

const getIngresosLey = async (params = {}) => await http_client(`/api/gestion-planilla/ingresos-ley`, params, "get");
const getIngresosInstitucionales = async (params = {}) => await http_client(`/api/gestion-planilla/ingresos-institucionales`, params, "get");
const getDescuentosLey = async (params = {}) => await http_client(`/api/gestion-planilla/descuentos-ley`, params, "get");
const getDescuentosInstitucionales = async (params = {}) => await http_client(`/api/gestion-planilla/descuentos-institucionales`, params, "get");
const guardarComplementariaConfiguracion = async (params = {}, suppressErrorAlert = false) => await http_client(`/api/gestion-planilla/complementaria/configuracion`, params, "post", {}, true, "json", undefined, suppressErrorAlert)
const exportarPlanilla = async (params) => await http_client(`/api/gestion-planilla/exportar-planilla`, params, "get", {}, true, "blob")
const aplicarRentaMensual = async (params = {}) => await http_client(`/api/gestion-planilla/aplicar-renta-mensual`, params, "post")

const enviarBoletaGrupal = async (idPlanilla) => await http_client(`/api/gestion-planilla/boleta-pago/enviar-grupal/${idPlanilla}`, {}, "post")
const imprimirBoletaGrupal = async (idPlanilla) => await http_client(`/api/gestion-planilla/boleta-pago/${idPlanilla}/unificadas`, {}, "get", {}, true, "blob")

const eliminarEmpleado = async (params = {}) => await http_client(`/api/gestion-planilla/empleado`, params, "delete")

// Elimina empleados en bloque ({ todos: true } o { ids: [...] }) del modal de refrescar cálculos
const eliminarEmpleadosPlanilla = async (idPlanilla, params = {}) => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/empleados`, params, "delete")

const refrescarCalculos = async (idPlanilla) => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/reiniciar`, {}, "post")

// Recalcula ISSS/Renta de los empleados marcados (refrescar_calculos) de la planilla ({ todos: true } o { ids: [...] })
const refrescarCalculosEmpleados = async (idPlanilla, params = {}) => await http_client(`/api/gestion-planilla/planilla/${idPlanilla}/refrescar-calculos-empleados`, params, "post")

const guardarDocRenta = async (body) => await http_client(`/api/gestion-planilla/planilla/guardar-documento-renta`, body, "post", { "Content-Type": "multipart/form-data", })
const obtenerDocRenta = async (params = {}) => await http_client(`/api/gestion-planilla/planilla/renta/documentos`, params, "get");
const verDocRenta = async (idDoc) => await http_client(`/api/gestion-planilla/planilla/renta/documento/${idDoc}`, {}, "get", {}, true, "blob");
const eliminarDocRenta = async (idDoc) => await http_client(`/api/gestion-planilla/planilla/renta/documento/${idDoc}`, {}, "delete")
const generarCartaRenta = async (idEmpleado) => await http_client(`/api/gestion-planilla/declaracion-renta/enviar/${idEmpleado}`, {}, "post")

// Responsable de planilla
const searchEmpleados = async (params = {}) => await http_client('/api/planilla/responsables/empleados-hacienda', params, "get")
const searchInstituciones = async (params = {}) => await http_client('/api/planilla/responsables/instituciones', params, "get")

const getResponsablesPlanilla = async (params = {}) => await http_client('/api/planilla/responsables', params, "get")
const saveResponsablePlanilla = async (body) => await http_client('/api/planilla/responsables', body, "post")
const deleteInstitution = async (id) => await http_client(`/api/planilla/responsables/${id}`, {}, "delete")
const patchResponsablePlanilla = async (id) => await http_client(`/api/planilla/responsables/cambiar-estado/${id}`, {}, "patch")

export default {
    getMeses,
    getYears,
    getSistemas,
    getTiposPlanilla,
    getPlanillas,
    getDetalleEmpleado,
    getIngresosDeducciones,
    getEspecificoGastos,
    getIngresos,
    createPlanilla,
    getPlanillaAperturada,
    getCategoriaDescuentos,
    getTipoAcreedor,
    getAcreedor,
    getSobreIngresos,
    getIndexPlanilla,
    closePeriodoJustificacion,
    closePlanilla,
    getDetallePlaza,
    guardarEmpleadoComplementaria,
    getEmpleadoComplementataria,
    getPlazaEmpleado,
    getEstados,
    desbloquearNomina,
    getIngresosLey,
    getEspecificoGasto,
    getOtrosIngresos,
    getFormaCalculo,
    getCifrados,
    modificarIngresosLey,
    addOtroIngreso,
    deleteOtroIngreso,
    updateOtroIngreso,
    getUnidades,
    getListaIngresos,
    deleteEmpleadoComplementaria,
    iniciarConfiguracion,
    getEmpleadoConfigurar,
    finalizarConfiguracionNomina,
    estadoEditarNomina,
    obtenerAportesPatronales,
    actualizarEspecificoGasto,
    obtenerCategoriasDescuentos,
    categoriaDescuentoPlanilla,
    ingresoEmpleadoDescuento,
    obtenerIngresosDeduccionLey,
    eliminarDescuenoIngreso,
    getOtroIngreso,
    otroIngresoEmpleado,
    postRentaIngreso,
    deleteRentaIngreso,
    eliminarOtroIngresoEmpleado,
    procesarEstadoPlanilla,
    procesarEstadoPlanillaFD,
    verBoletaPago,
    enviarBoleta,
    enviarBoletas,
    getObservaciones,
    descargarArchivo,
    archivosSafi,
    openPeriodoJustificacion,
    obtenerJustificaciones,
    obtenerDocumentoJustificacion,
    listarCifrados,
    actualizarCifrados,
    boletasEnviadas,
    getEmpleadosUnidadFinanciera,
    getEstadoPlanilla,
    aperturarPlanilla,
    getInformacionPlanilla,
    getEstadoCargaEmpleado,
    getEmpleadosPlanilla,
    getTipoDocumento,
    getTipoUnidadOrganizativa,
    verificacionEmpleado,
    justificarInconsistencia,
    registrarMovimientoEmpleado,
    listarMovimientosEmpleado,
    obtenerDocumentoMovimiento,
    cambiarFase,
    asignarMuestra,
    getHistoricoReapertura,
    getEmpleadosSelect,
    getEmpleadosComplementaria,
    getEmpleadosQuincenaVeinticinco,
    guardarEmpleadosQuincenaVeinticinco,
    getEmpleadosQuincenaVeinticincoHacienda,
    getEmpleadosAguinaldo,
    guardarEmpleadosAguinaldo,
    enviarBoletasDePago,
    balanceoEmpleado,
    verificarEmpleado,
    historicoRenta,
    abrirPeriodoJustificacion,
    crearHistoricoRenta,
    guardarConstanciaRenta,
    descargarConstanciaRenta,
    descargarBoletaPago,
    getIngresosInstitucionales,
    getDescuentosLey,
    getDescuentosInstitucionales,
    guardarComplementariaConfiguracion,
    exportarPlanilla,
    aplicarRentaMensual,
    enviarBoletaGrupal,
    imprimirBoletaGrupal,
    eliminarEmpleado,
    eliminarEmpleadosPlanilla,
    refrescarCalculos,
    refrescarCalculosEmpleados,
    listarCifradosSistemaPago,
    guardarDocRenta,
    obtenerDocRenta,
    verDocRenta,
    eliminarDocRenta,
    generarCartaRenta,
    // Responsables de planilla
    searchEmpleados,
    searchInstituciones,
    getResponsablesPlanilla,
    saveResponsablePlanilla,
    deleteInstitution,
    patchResponsablePlanilla,
    getPlanillasHacienda,
    getInformacionPlanillaHacienda
}
